import cuid from "cuid";
import { defaults, get, isEmpty, keyBy } from "lodash";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { CREATE_QUALIFICATION } from "utils/api/graphql/mutations/qualifications";
import { QUALIFIERS } from "utils/api/graphql/queries/qualifiers";
import {
  ACORIS_PHONE_PREFIXES,
  CONTACT_POINT_SYSTEM,
  QUALIFIER_TAGS,
} from "utils/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const ContactAdvisor = ({ project, onNext, onBack, currentStatus, tracer }) => {
  const { data } = useQuery(QUALIFIERS, {
    variables: {
      where: {
        tag: QUALIFIER_TAGS.CALL_LATER,
      },
      take: 1,
    },
  });

  const [addQualification] = useMutation(CREATE_QUALIFICATION, {
    refetchQueries: [
      {
        query: QUALIFIERS,
        awaitRefetchQueries: true,
        variables: {
          withDeleted: true,
          where: {
            qualifications: {
              contact: { id: get(project, "contact.id") },
            },
          },
        },
      },
    ],
  });

  const telecomsObject = defaults(
    keyBy(get(project, "contact.telecoms", []), "system"),
    {
      [CONTACT_POINT_SYSTEM.PHONE]: { value: null },
      [CONTACT_POINT_SYSTEM.EMAIL]: { value: null },
    },
  );

  const onSubmit = (advisorValues) => {
    const contactId = get(project, "contact.id") || cuid();

    if (!isEmpty(get(data, "qualifiers.0.id"))) {
      addQualification({
        variables: {
          data: {
            id: cuid(),
            qualifier: { id: get(data, "qualifiers.0.id") },
            contact: { id: contactId },
          },
        },
      });
    }

    const existingTelecoms = keyBy(
      get(project, "contact.telecoms", []),
      "system",
    );
    const phoneTelecom = defaults(
      existingTelecoms[CONTACT_POINT_SYSTEM.PHONE],
      { id: cuid(), system: CONTACT_POINT_SYSTEM.PHONE },
    );
    const phonePrefixTelecom = defaults(
      existingTelecoms[CONTACT_POINT_SYSTEM.PHONE_NUMBER_PREFIX],
      { id: cuid(), system: CONTACT_POINT_SYSTEM.PHONE_NUMBER_PREFIX },
    );
    const emailTelecom = defaults(
      existingTelecoms[CONTACT_POINT_SYSTEM.EMAIL],
      { id: cuid(), system: CONTACT_POINT_SYSTEM.EMAIL },
    );

    return onNext({
      payload: {
        contact: {
          id: contactId,
          user: {
            id: get(project, "contact.user.id") || cuid(),
            firstname: advisorValues.firstname,
            lastname: advisorValues.lastname,
            birthDate: get(project, "contact.user.birthDate"),
          },
          telecoms: [
            ...get(project, "contact.telecoms", []).filter(
              (item) =>
                item.system !== CONTACT_POINT_SYSTEM.PHONE &&
                item.system !== CONTACT_POINT_SYSTEM.PHONE_NUMBER_PREFIX &&
                item.system !== CONTACT_POINT_SYSTEM.EMAIL,
            ),
            {
              ...phoneTelecom,
              value: advisorValues.phone
                ? String(advisorValues.phone).replace(/\s+/g, "")
                : null,
            },
            {
              ...phonePrefixTelecom,
              value:
                advisorValues.phonePrefix || ACORIS_PHONE_PREFIXES[0].value,
            },
            {
              ...emailTelecom,
              value: advisorValues.email,
            },
          ],
          fields: {
            ...get(project, "contact.fields", {}),
            isClient: true,
            memberNumber: advisorValues.memberNumber,
            acceptEmailSms: advisorValues.acceptEmailSms,
            acceptPhone: advisorValues.acceptPhone,
            contactAdvisorRequested: true,
          },
        },
        visible: true,
      },
    });
  };

  return (
    <>
      <Navbar project={project} currentStatus={currentStatus} tracer={tracer} />
      <View
        contact={get(project, "contact", {})}
        telecoms={telecomsObject}
        onSubmit={onSubmit}
        onBack={onBack}
        initialMemberNumber={get(project, "contact.fields.memberNumber", "")}
      />
    </>
  );
};

export default ContactAdvisor;
